import type { ReactNode } from "react";

interface MobileNavigationHeaderProps {
	children: ReactNode;
}

export const MobileNavigationHeader = ({ children }: MobileNavigationHeaderProps) => (
	<div className="absolute w-fit p-2.5 lg:hidden" style={{ zIndex: "var(--z-index-header-navigation)" }}>
		{children}
	</div>
);
